import { asyncRouterMap, constantRouterMap } from "@/router/index";
import { filterGrowthRoutes } from "@/utils/growthAccess";

//判断是否有权限访问该菜单
//topLevel: true=顶级路由，false=子路由；用于在同名菜单(顶级与子级重名)时取对应层级的那条
function hasPermission(menus, route, topLevel) {
  if (route.name) {
    let currMenu = getMenu(route.name, menus, topLevel);
    if (currMenu != null) {
      //设置菜单的标题、图标和可见性
      if (currMenu.title != null && currMenu.title !== "") {
        route.meta.title = currMenu.title;
      }
      if (currMenu.icon != null && currMenu.title !== "") {
        route.meta.icon = currMenu.icon;
      }
      if (currMenu.hidden != null) {
        route.hidden = currMenu.hidden !== 0;
      }
      if (currMenu.sort != null && currMenu.sort !== "") {
        route.sort = currMenu.sort;
      }
      return true;
    } else {
      route.sort = 0;
      if (route.hidden !== undefined && route.hidden === true) {
        route.sort = -1;
        return true;
      } else {
        return false;
      }
    }
  } else {
    return true;
  }
}

//根据路由名称获取菜单
//存在顶级与子级重名的菜单(如 interaction/member)时，按 topLevel 取对应层级的那条，
//避免顶级路由错误匹配到 sort 更小、排在数组前面的子菜单
function getMenu(name, menus, topLevel) {
  let fallback = null;
  for (let i = 0; i < menus.length; i++) {
    let menu = menus[i];
    if (name === menu.name) {
      let isTop = menu.parentId === 0 || menu.parentId === "0";
      if (topLevel === undefined) return menu; //不区分层级时返回第一个
      if (topLevel && isTop) return menu; //顶级路由匹配 parentId=0 的菜单
      if (!topLevel && !isTop) return menu; //子路由匹配非顶级菜单
      if (fallback === null) fallback = menu; //层级对不上时先记一个候补
    }
  }
  return fallback;
}

//对菜单进行排序
function sortRouters(accessedRouters) {
  for (let i = 0; i < accessedRouters.length; i++) {
    let router = accessedRouters[i];
    if (router.children && router.children.length > 0) {
      router.children.sort(compare("sort"));
    }
  }
  accessedRouters.sort(compare("sort"));
}

//将 sort 值规整为数字；空/null/undefined/非数字一律沉到底部，避免 NaN 打乱排序
function toSortNum(v) {
  if (v === null || v === undefined || v === "") return 9999;
  let n = Number(v);
  return isNaN(n) ? 9999 : n;
}

//升序比较函数（按 sort 从小到大）
function compare(p) {
  return function (m, n) {
    return toSortNum(m[p]) - toSortNum(n[p]);
  };
}

const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: [],
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers;
      state.routers = constantRouterMap.concat(routers);
    },
  },
  actions: {
    GenerateRoutes({ commit }, data) {
      return new Promise((resolve) => {
        const { menus, username, roles } = data;
        const candidateRouters = filterGrowthRoutes(asyncRouterMap, roles);
        const accessedRouters = candidateRouters.filter((v) => {
          //admin帐号直接返回所有菜单
          // if(username==='admin') return true;
          if (hasPermission(menus, v, true)) {
            if (v.children && v.children.length > 0) {
              v.children = v.children.filter((child) => {
                if (hasPermission(menus, child, false)) {
                  return child;
                }
                return false;
              });
              return v;
            } else {
              return v;
            }
          }
          return false;
        });
        //对菜单进行排序
        sortRouters(accessedRouters);
        commit("SET_ROUTERS", accessedRouters);
        resolve(accessedRouters);
      });
    },
  },
};

export default permission;
